import { h, defineComponent, SetupContext, ref, computed } from 'vue';
// @ts-ignore
import { BTaginput } from 'buefy/dist/esm/taginput';
import { SelectOptions, SelectOptionsWithId } from '@/ui/types';
import { t } from '@/ui/i18n/i18n';
import { Icon } from '@/ui/components/icon/Icon';

export interface FreeTagInputProps<T = number> {
  value: T[];
  data?: SelectOptions<string | number> | SelectOptionsWithId<string | number>;
  disabled: boolean;
  icon?: string;
  placeholder?: string;
  addLabel?: string;
  addLabelEmptyValue?: string;
  autocomplete?: boolean;
  openOnFocus?: boolean;
}

export const FreeTagInput = defineComponent<FreeTagInputProps>({
  name: 'FreeTagInput',
  props: ['value', 'data', 'icon', 'disabled', 'placeholder', 'autocomplete', 'openOnFocus', 'addLabel', 'addLabelEmptyValue'],
  setup(props, context: SetupContext) {
    const bTagInput = ref<BTaginput | null>(null);
    const searchValue = ref('');
    const filteredData = computed(() => {
      return props.data?.filter(option => {
        return option.label
          .toString()
          .toLowerCase()
          .indexOf(searchValue.value.toLowerCase()) >= 0;
      });
    });

    return function render() {
      return h(BTaginput, {
        props: {
          value: props.value,
          icon: props.icon,
          data: filteredData.value,
          attached: true,
          ellipsis: true,
          allowNew: true,
          openOnFocus: props.openOnFocus,
          autocomplete: props.autocomplete,
        },
        scopedSlots: {
          default(defaultProps) {
            return context.slots.default && context.slots.default(defaultProps);
          },
        },
        ref: bTagInput,
        attrs: {
          disabled: props.disabled,
          placeholder: props.placeholder,
        },
        on: {
          input: (value: unknown[]) => {
            const getUnique = (data: unknown[]) => [...new Set(data)];

            // @ts-ignore
            context.emit('input', getUnique(value.map(v => v.label || v)));
          },
          typing: (value: string) => {
            searchValue.value = value;
          },
        },
      }, [
        h('template', { slot: 'empty' }, [
          context.slots.empty && context.slots.empty(),
        ]),
        h('template', { slot: 'header' }, [
          props.addLabel && [
            h('a', {
              class: 'tag-input__add-tag',
              on: {
                click: () => {
                  bTagInput.value?.addTag();
                },
              },
            }, [
              h(Icon, { props: { icon: 'plus' } }),
              !searchValue.value && props.addLabelEmptyValue
                ? t(props.addLabelEmptyValue)
                : t(props.addLabel, { label: searchValue.value }),
            ]),
          ],
        ]),
      ]);
    };
  },
});
